import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { DoodApiError } from '@shared/interfaces/error.interface';
import { UpsellingData } from './upselling.model';

export const UPSELLING_STORE_API_ACTIONS = createActionGroup({
  source: 'Dood/API/Upselling',
  events: {
    'Load Upselling': emptyProps(),
    'Load Upselling Success': props<{ data: UpsellingData }>(),
    'Load Upselling Failure': props<{ error: DoodApiError }>(),
    'Load Upselling Complete': emptyProps(),
  },
});

export const UPSELLING_STORE_COMPONENT_ACTIONS = createActionGroup({
  source: 'Dood/COMPONENT/Upselling',
  events: {
    'Show Upselling Proposals': props<{ triggerProductId: string }>(),
  },
});
